import React from "react";
import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category = "Blog category") => {
  const eventTracker = (action = "test action", label = "test label") => {
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};

//analytics
const eventTrackerAnalytics = (category, action, label) => {
  console.log("GA event:", category, ":", action, ":", label);
  return ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};
export default eventTrackerAnalytics;
